export const isTouchDevice = (): boolean =>
	"ontouchstart" in window || navigator.maxTouchPoints > 0;
